import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {UnitsProductModelService} from '../../../Models/Purchases/Products/units-product-model.service';

@Injectable({
  providedIn: 'root'
})
export class UnitsProductApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: UnitsProductModelService
  ) {
    super(injector);
  }


  /**
   * Obtener las unidades de los productos
   *
   */
  public getUnitsProduct(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getUnidadesProducto', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
